export default __webpack_public_path__ + "static/article-5-things-you-should-look-for-in-a-builder-818b73da8019f2b46a00d38b5e83de29.webp";